<app-main-nav-bar></app-main-nav-bar>
<div class="page-wrapper bg-red p-t-180 p-b-100">
  <div class="wrapper wrapper--w960">
    <div class="card card-2">
      <div class="card-body">
        <div class="main" data-request="1335">
          <div class="wrap">
            <div class="offer elem" style="display: block;">
              <div class="row">
                <div class="col col-12">
                  <div class="head">
                    <h3>اطلاعات اولیه</h3>
                    <p>لطفا اطلاعات زیر را با دقت تکمیل نمایید</p>
                  </div>
                </div>
              </div>
              <br>
              <div *ngIf="forms">
                <app-form [formGroup]="forms[0].formGroup" [questions]="forms[0].questionsList" [productName]="productName" [translation]="translation"></app-form>
              </div>
            </div>
            <br>
            <app-custom-button
              [BackButton]="true"
              [backUrl]="'/individual-accidents'"
              (OnClick)="goNext()"
              [LabelText]="'ادامه'"
              [Show]="true">
            </app-custom-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
